import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Choisissez le nombre approprié de panneaux solaires, de batterie et d'onduleur";
const DESCRIPTION =
  "Choisissez le nombre approprié de panneaux solaires, de batterie et d'onduleur. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "solar calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/solar-calculator/";
function SolarCalculator() {
  const [consumption, setConsumption] = useState(0);
  const [sunHours, setSunHours] = useState(4);
  const [panelWattage, setPanelWattage] = useState(100);
  const [batteryVoltage, setBatteryVoltage] = useState(24);
  const [cloudyDays, setCloudyDays] = useState(2);
  const [result, setResult] = useState(null);
  const handleCalculate = () => {
    const totalConsumption = consumption * 1.3;
    const panelPowerNeeded = totalConsumption / sunHours;
    const numberOfPanels = Math.ceil(panelPowerNeeded / panelWattage);
    const batteryCapacityNeeded =
      (totalConsumption * cloudyDays * 1.3) / batteryVoltage;
    const numberOfBatteries = Math.ceil(batteryCapacityNeeded / 80);
    const inverterSize = (220 * 1.3).toFixed(2);
    setResult({
      panelPowerNeeded: panelPowerNeeded.toFixed(2),
      numberOfPanels,
      batteryCapacityNeeded: batteryCapacityNeeded.toFixed(2),
      numberOfBatteries,
      inverterSize,
    });
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Notre calculatrice gratuite vous offre un outil facile à utiliser pour calculer le système d'énergie solaire idéal pour votre maison. Entrez simplement vos données de consommation actuelles et votre localisation géographique, et obtenez une estimation précise du nombre de panneaux solaires, de batteries et du contrôleur nécessaire pour répondre à vos besoins. Profitez de l'énergie propre et gratuite, et économisez sur vos factures d'électricité avec un système d'énergie solaire conçu spécifiquement pour vous.
                </p>
                <p>Pour calculer votre système d'énergie solaire, suivez les étapes suivantes :</p>
                <ul>
                  <li>Estimez la quantité d'énergie consommée par jour.</li>
                  <li>Calculez le nombre de panneaux solaires requis.</li>
                  <li>Calculez le nombre de batteries requises.</li>
                  <li>Calculez la taille du contrôleur solaire et de l'onduleur.</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="consumption">
                      <label className="form-label ms-2">
                        Entrez la consommation énergétique totale par jour (Watt/heure)
                      </label>
                      <input
                        id="consumption"
                        type="number"
                        value={consumption}
                        onChange={(e) => setConsumption(e.target.value)}
                        placeholder="Entrez la consommation énergétique totale"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="sunHours">
                      <label className="form-label ms-2">
                        Entrez le nombre d'heures de soleil par jour
                      </label>
                      <input
                        id="sunHours"
                        type="number"
                        value={sunHours}
                        onChange={(e) => setSunHours(e.target.value)}
                        placeholder="Heures de soleil"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="panelWattage">
                      <label className="form-label ms-2">
                        Puissance du panneau solaire (Watt)
                      </label>
                      <input
                        id="panelWattage"
                        type="number"
                        value={panelWattage}
                        onChange={(e) => setPanelWattage(e.target.value)}
                        placeholder="Puissance du panneau"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="batteryVoltage">
                      <label className="form-label ms-2">
                        Tension de la batterie (Volt)
                      </label>
                      <input
                        id="batteryVoltage"
                        type="number"
                        value={batteryVoltage}
                        onChange={(e) => setBatteryVoltage(e.target.value)}
                        placeholder="Tension de la batterie"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="cloudyDays">
                      <label className="form-label ms-2">
                        Jours nuageux (autonomie)
                      </label>
                      <input
                        id="cloudyDays"
                        type="number"
                        value={cloudyDays}
                        onChange={(e) => setCloudyDays(e.target.value)}
                        placeholder="Jours autonomie"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {result && (
                    <div className="p-3 mb-2 bg-info text-black">
                      <h4>Résultats :</h4>
                      <p><strong>Puissance du panneau requise :</strong> {result.panelPowerNeeded} W</p>
                      <p><strong>Nombre de panneaux :</strong> {result.numberOfPanels}</p>
                      <p><strong>Capacité de batterie requise :</strong> {result.batteryCapacityNeeded} Ah</p>
                      <p><strong>Nombre de batteries :</strong> {result.numberOfBatteries}</p>
                      <p><strong>Taille de l'onduleur :</strong> {result.inverterSize} W</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default SolarCalculator;
